var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCoverButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23430_28057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.17578C13 4.86434 14.1195 3.80078 15.5 3.80078C16.8812 3.80078 18 4.86434 18 6.17578C18 7.48796 16.8812 8.55078 15.5 8.55078C14.1195 8.55078 13 7.48796 13 6.17578Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02526 0.714844H12.9734C14.71 0.714844 16.1101 0.714844 17.2109 0.836835C18.3537 0.964741 19.3162 1.23682 20.0806 1.86969C20.8449 2.50256 21.1743 3.29959 21.3279 4.246C21.4752 5.15761 21.4752 6.31683 21.4752 7.75492V11.0242C21.4752 11.8175 21.4752 12.5251 21.4511 13.1543C21.4672 13.212 21.4752 13.2718 21.4752 13.3325V14.1213C21.4752 16.2987 19.3431 18.0643 16.7136 18.0643H5.28504C2.65464 18.0643 0.523438 16.2987 0.523438 14.1213V13.3325C0.523438 13.2718 0.531473 13.212 0.547545 13.1543C0.523437 12.5251 0.523438 11.8175 0.523438 11.0242V7.75492C0.523438 6.31689 0.523437 5.15754 0.670759 4.246C0.825223 3.29964 1.1538 2.50264 1.91807 1.86969C2.68235 1.23675 3.64486 0.964745 4.78779 0.836835C5.88868 0.714844 7.28857 0.714844 9.02526 0.714844ZM19.5709 10.9666C19.5709 11.3141 19.5709 11.6372 19.5691 11.9388L17.8387 11.0789C16.5468 10.4372 14.9146 10.5074 13.7093 11.2556C12.8817 11.7695 11.7031 11.6024 11.1299 10.8897L10.9022 10.6065C9.53886 8.91414 6.69516 8.58886 4.83001 9.91299L2.4291 11.6179C2.42821 11.4109 2.42821 11.1935 2.42821 10.9666V7.81252C2.42821 6.30278 2.42999 5.24997 2.55946 4.45597C2.68446 3.68484 2.91392 3.27598 3.2648 2.98469C3.6166 2.69412 4.11034 2.50411 5.04158 2.40061C6.00051 2.29341 7.27194 2.29193 9.09507 2.29193H12.904C14.7272 2.29193 15.9986 2.29341 16.9575 2.40061C17.8887 2.50412 18.3825 2.69414 18.7342 2.98469C19.0851 3.276 19.3146 3.68484 19.4396 4.45597C19.5691 5.25003 19.5708 6.30285 19.5708 7.81252L19.5709 10.9666Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23430_28057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCoverButton);
export default __webpack_public_path__ + "static/media/event_cover_button.5e0300f556a1107bf86bdfeb3fa35989.svg";
export { ForwardRef as ReactComponent };